import { Grid, HStack, SkeletonText, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { TitlePageDashboard } from "../../../components/button/TitlePageDashboard";
import { FavoriteProductCard } from "../../../components/dashboard_buyer_page/FavoriteProductCard";
import { CardSkeleton } from "../../../components/skeleton/CardSkeleton";
import { FavoriteItem } from "../../../constants/Favorite";
import useCustomToast from "../../../lib/useCustomToast";
import { axiosBuyer } from "../../../utils/AxiosInstance";
import { useTriggerRenderStore } from "../../../store/useTriggerRenderStore";

export const Favorite = () => {
  const [data, setData] = useState<FavoriteItem[] | undefined>(undefined);
  const [loaded, setLoaded] = useState<boolean>(false);
  const toast = useCustomToast();
  const { statusData, setStatusData } = useTriggerRenderStore();

  useEffect(() => {
    axiosBuyer
      .get(`/v1/buyer/favorite`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [statusData]);

  return (
    <VStack className="favorite-page" w={"100%"} p={4} align={"stretch"}>
      <TitlePageDashboard title="Produk Favorit" />

      <HStack w={"100%"} justify={"space-between"}>
        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
          <Text textStyle={"b-reg"}>{`${data?.length} Produk`}</Text>
        </SkeletonText>
      </HStack>

      {!loaded ? (
        <CardSkeleton w={"100%"} row={3} column={2} height={300} />
      ) : (
        <Grid
          w={"100%"}
          templateColumns={"repeat(auto-fill, minmax(180px, 1fr))"}
          gap={"20px"}
          mt={4}
        >
          {data?.map((item, i) => (
            <FavoriteProductCard
              key={i}
              data={item}
              onRefresh={() => setStatusData()}
            />
          ))}
        </Grid>
      )}
    </VStack>
  );
};
